import OrganizationsService from "@/api/services/organizations";
import { toCamelCase } from "@estaly/ui";

// Keywords can change while a request is still pending: only the latest request may write its results.
let latestIndexRequest = 0;

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, data) {
      state.index = data.organizations || [];
      state.currentPage = data.page?.currentPage || 1;
      state.totalPages = data.page?.totalPages || 0;
      state.totalCount = data.page?.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const requestId = ++latestIndexRequest;
      const response = await OrganizationsService.fetchIndex(params);
      const isLatest = requestId === latestIndexRequest;
      if (isLatest && response?.success) commit("setIndex", toCamelCase(response.data));

      return { ...response, isLatest };
    },
  },
};
